import React, { useRef, useEffect } from "react";

const messages = [
  "WELCOME TO SYUKRA — PREMIUM CLOTHING FOR YOU",
  "ENJOY FREE SHIPPING ABOVE ₹2000",
  "FOLLOW US ON INSTAGRAM FOR THE LATEST LAUNCHES!",
  "NEW ARRIVALS DROPPING SOON!",
  "15% OFF ON EVERYTHING"
];

const ScrollingStrip = () => {
  const stripRef = useRef(null);
  const containerRef = useRef(null);
  let animationFrameId;

  useEffect(() => {
    const strip = stripRef.current;
    const container = containerRef.current;
    let position = 0;

    // Calculate the width of one full set of messages dynamically
    const fullScrollWidth = strip.scrollWidth / 2;

    const scrollSpeed = 0.5; // pixels per frame, adjust as needed

    const animate = () => {
      position -= scrollSpeed;

      // Reset position seamlessly after one full scroll cycle (half of scrollWidth)
      if (Math.abs(position) >= fullScrollWidth) {
        position = 0;
      }

      strip.style.transform = `translateX(${position}px)`;
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="scrolling-strip"
      style={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1050,
        backgroundColor: "var(--primary-color)",
        borderBottom: "1px solid var(--border-light)",
        padding: "0.3rem 0",
      }}
    >
      <div
        ref={stripRef}
        style={{
          display: "inline-flex",
          userSelect: "none",
          fontFamily: `"Jost", "Poppins", "Segoe UI", sans-serif`,
          fontWeight: 500,
          color: "var(--background-offwhite)",
          gap: "3rem",
        }}
      >
        {[...messages, ...messages, ...messages, ...messages].map((msg, i) => (
          <span key={i} style={{ whiteSpace: "nowrap" }}>
            {msg}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ScrollingStrip;
